export default __webpack_public_path__ + "static/media/ftj-8.75f5d777.jpeg";